export default __webpack_public_path__ + "static/thumb-landscape-efbae3cfed8f62f777ec112fde243ed1.jpg";